module.exports = __webpack_public_path__ + "static/media/voteRegister.bab7ffa6.png";